import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        equipmentBRCs: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        equipmentBRCMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getEquipmentBRCsRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveEquipmentBRCs", null);
            } else {
                dispatch("receivingEquipmentBRCs"); // สถานะ กำลังบันทึก

                const formData = new FormData();
                formData.append('item_type_master_code', payload.item_type_master_code);
                // formData.append('news_type_tag', payload.news_type_tag); วันที่จะยืม
                // formData.append('news_type_tag', payload.news_type_tag); วันที่จะคืน
                axios.get('/equipment_brcs', {params: payload})
                    .then(function (res) {
                        dispatch("receiveEquipmentBRCs", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveEquipmentBRCs", null);
                    });

            }
        },
        loadEquipmentBRCRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveEquipmentBRC", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingEquipmentBRC");
                axios.get('/equipment_brcs/' + id).then(res => {
                    dispatch("receiveEquipmentBRC", res.data);
                })
            }
        },
        updateEquipmentBRCRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingEquipmentBRC");
            const formData = new FormData();
            // formData.append('file', payload.avatarFile);
            formData.append('borrowing_id', payload.borrowing_id);
            formData.append('borrowing_status', payload.borrowing_status);
            formData.append('remark', payload.remark);

            axios.post('/update_equipment_brcs', formData).then(res => {
                console.log('update')
                console.log(res.data)
                dispatch("updateEquipmentBRC", res.data);
            })

        },

        receiveEquipmentBRCs({commit}, payload) {
            commit("RECEIVED_DATAS", payload)
        },
        receivingEquipmentBRCs({commit}) {
            commit("RECEIVING_DATAS") //call matutions --> state.isReceiving = true;
        },
        receiveEquipmentBRC({commit}, payload) {
            commit("RECEIVED_DATA", payload)
        },
        receivingEquipmentBRC({commit}) {
            commit("RECEIVING_DATAS") //call matutions --> state.isReceiving = true;
        },
        updateEquipmentBRC({commit}, payload) {
            commit("UPDATED_DATA", payload)
        },
        updatingEquipmentBRC({commit}) {
            commit("UPDATING_DATA") //  call matutions --> state.isUpdating = true;
        },
        deleteEquipmentBRC({commit}, payload) {
            commit("DELETED_DATA", payload)
        },
        deletingEquipmentBRC({commit}, payload) {
            commit("DELETING_DATA", payload)
        },
        afterDeleteEquipmentBRC({commit}, payload) {
            commit("AFFTER_DELETED_DATA", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_DATAS(state, payload) {
            state.equipmentBRCs = payload;
            state.isReceiving = false;

        },
        RECEIVING_DATAS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_DATA(state, payload) {

            console.log(payload)


            if (payload.borrowing_id == undefined) {
                let error = payload.e.errorInfo == undefined ? payload.message : payload.e.errorInfo.toString()
                let equipmentBRCMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    equipmentBRCMessage: (state.equipmentBRCMessage == equipmentBRCMessage ? equipmentBRCMessage + ' ' : equipmentBRCMessage),

                });
            } else {
                let equipmentBRCMessage = 'บันทึกสำเร็จ! รายการ ' + payload.borrowing_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    equipmentBRCs: [...state.equipmentBRCs, payload],
                    isReceiving: false,
                    errorMessage: false,
                    equipmentBRCMessage: (state.equipmentBRCMessage == equipmentBRCMessage ? equipmentBRCMessage + ' ' : equipmentBRCMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_DATA(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_DATA(state, payload) {
            let index = state.equipmentBRCs.findIndex(p => p.borrowing_id === payload.borrowing_id);
            let equipmentBRCMessage = 'บันทึกสำเร็จ! รายการ ' + payload.borrowing_id + ' ถูกแก้ไขแล้ว';

            state = Object.assign(state, {
                equipmentBRCs: state.equipmentBRCs.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                equipmentBRCMessage: (state.equipmentBRCMessage == equipmentBRCMessage ? equipmentBRCMessage + ' ' : equipmentBRCMessage),
            })
        },
        UPDATING_DATA(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_DATA(state, payload) {
            console.log(payload)


            if (payload.res.data.borrowing_id == undefined || payload.res.data.message == 'Relation') {
                let equipmentBRCMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.borrowing_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    equipmentBRCMessage: (state.equipmentBRCMessage == equipmentBRCMessage ? equipmentBRCMessage + ' ' : equipmentBRCMessage),

                });
            } else {
                let indexToDelete = state.equipmentBRCs.findIndex(p => p.borrowing_id === payload.res.data.borrowing_id);
                let equipmentBRCs = [...state.equipmentBRCs];
                equipmentBRCs.splice(indexToDelete, 1);
                let equipmentBRCMessage = 'บันทึกสำเร็จ! รายการ ' + payload.res.data.borrowing_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    equipmentBRCs: [...equipmentBRCs],
                    isDeleting: false,
                    idToDelete: null,
                    equipmentBRCMessage: (state.equipmentBRCMessage == equipmentBRCMessage ? equipmentBRCMessage + ' ' : equipmentBRCMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_DATA(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.borrowing_id;
        },
        AFFTER_DELETED_DATA(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
